import { http, pagination, id } from 'utils'
import { SET_GRADUATES, SET_META, ADD_GRADUATES, ADD_GRADUATE } from 'vx/mutations'
import { concat, findIndex } from 'lodash'

const rootProgram = (rootState, program) => id(program || rootState.programs.program)

const state = {
  graduates: [],
  meta: null
}

const getters = {}

const actions = {
  async getGraduates ({ commit, rootState }, { program, next = false, params = {} } = {}) {
    if (next) {
      if (pagination(state.meta)) {
        return Promise.reject(new Error('No more results.'))
      }

      params.page = state.meta.current_page + 1
    }

    const response = await http.get(`programs/${rootProgram(rootState, program)}/graduates`, { params })

    if (next) {
      commit(ADD_GRADUATES, response.data.data)
    } else {
      commit(SET_GRADUATES, response.data.data)
    }

    commit(SET_META, response.data.meta)

    return response
  },

  async updateManagerAssignment ({ commit, state, rootState }, { program, placement, manager, graduate }) {
    const response = await http.put(`programs/${rootProgram(rootState, program)}/manager-assignments`, {
      placement: id(placement),
      manager: id(manager),
      graduate: id(graduate)
    })

    commit(ADD_GRADUATE, response.data.data)

    return response
  },

  async storeGraduate ({ commit, rootState }, payload) {
    const response = await http.post(`programs/${id(rootState.programs.program)}/graduates`, payload)

    commit(ADD_GRADUATE, response.data.data)

    return response
  },

  /**
   * Activate a program's disabled graduates
   */
  async activateGraduates ({ commit, rootState }, program) {
    const response = await http.post(`programs/${rootProgram(rootState, program)}/graduates/activate`)

    return response
  },

  resetGraduates ({ commit }) {
    commit(SET_GRADUATES, [])
    commit(SET_META, null)
  }
}

// Graduates state mutations.
const mutations = {
  [SET_GRADUATES] (state, graduates) {
    state.graduates = graduates
  },

  [ADD_GRADUATES] (state, graduates) {
    state.graduates = concat(state.graduates, graduates)
  },

  [SET_META] (state, meta) {
    state.meta = meta
  },

  [ADD_GRADUATE] (state, graduate) {
    let index = findIndex(state.graduates, existing => existing.id === graduate.id)

    if (index !== -1) {
      state.graduates.splice(index, 1, graduate)
    } else {
      state.graduates.unshift(graduate)
    }
  }
}

// Export our state, getters, actions, and mutations.
export default {
  namespaced: true, state, getters, actions, mutations
}
